import script from "./NewsPagePopupTelegramBlock.vue?vue&type=script&setup=true&lang=js"
export * from "./NewsPagePopupTelegramBlock.vue?vue&type=script&setup=true&lang=js"

import "./NewsPagePopupTelegramBlock.vue?vue&type=style&index=0&id=3f260c41&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3f260c41"]])

export default __exports__